import "./BulkTestOrderViewComponent.scss";
import {useNavigate, useParams} from "react-router-dom";
import React, {useCallback, useEffect, useState} from "react";
import CommonService from "../../../shared/services/common.service";
import {IAPIResponseType} from "../../../shared/models/api.model";
import StatusCardComponent from "../../../shared/components/status-card/statusCardComponent";
import CardComponent from "../../../shared/components/card/cardComponent";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import Grid from "@mui/material/Grid";
import DetailsDataKeyValueComponent
    from "../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import ImportBulkTestOrderComponent from "../import-bulk-test-order/importBulkTestOrderComponent";
import DrawerComponent from "../../../shared/components/drawer/drawerComponent";
import BulkTestOrderSessionListComponent from "../bulk-test-order-session-list/BulkTestOrderSessionListComponent";
import {ImageConfig} from "../../../constants";
import LottieFileGenarationComponent
    from "../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import commonService from "../../../shared/services/common.service";
import DialogComponent from "../../../shared/components/dialog/dialogComponent";

interface BulkTestOrderViewComponentProps {

}

interface testOrderModalConfigType {
    type: 'uploading' | 'generating',
    isOpen: boolean,
    totalCount: number,
    progressCount: number,
}

const initialTestOrderModalConfig: testOrderModalConfigType = {
    type: 'uploading',
    isOpen: false,
    totalCount: 0,
    progressCount: 0,
}
const MODULE_NAME = 'bulk-test-order-list';

const BulkTestOrderViewComponent = (props: BulkTestOrderViewComponentProps) => {
    const params = useParams<{ bulkOrderID: string }>();
    const {bulkOrderID} = params;
    const navigate=useNavigate();
    const [bulkOrderDetails, setBulkOrderDetails] = useState<any>(undefined);
    const [isBulkOrderDetailsLoading, setIsBulkOrderDetailsLoading] = useState<boolean>(false);
    const [isBulkOrderDetailsLoaded, setIsBulkOrderDetailsLoaded] = useState<boolean>(false);
    const [isBulkOrderDetailsLoadingFailed, setIsBulkOrderDetailsLoadingFailed] = useState<boolean>(false);
    const [isImportTestOrderDrawerOpen, setIsImportTestOrderDrawerOpen] = useState<boolean>(false);
    const [isGenerateResultLoading, setIsGenerateResultLoading] = useState<boolean>(false);
    const [testOrderModalConfig, setTestOrderModalConfig] = useState(initialTestOrderModalConfig);


    const getBulkOrderDetails = useCallback(() => {
        const payload = {};
        let bulkOrderDetails: any = {};
        setIsBulkOrderDetailsLoading(true);
        setIsBulkOrderDetailsLoaded(false);
        setIsBulkOrderDetailsLoadingFailed(false);
        CommonService._testOrder.getBulkOrderDetails(bulkOrderID, payload)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    bulkOrderDetails = response.data;
                }
                setBulkOrderDetails(bulkOrderDetails);
                setIsBulkOrderDetailsLoading(false);
                setIsBulkOrderDetailsLoaded(true);
                setIsBulkOrderDetailsLoadingFailed(false);
            })
            .catch((error: any) => {
                setBulkOrderDetails(bulkOrderDetails);
                setIsBulkOrderDetailsLoading(false);
                setIsBulkOrderDetailsLoaded(false);
                setIsBulkOrderDetailsLoadingFailed(true);
            });
    }, [bulkOrderID]);

    const getBulkTestOrderListCount = useCallback(() => {
        setIsBulkOrderDetailsLoading(true);
        CommonService._testOrder.getBulkTestOrderListCount(bulkOrderID).then(res => {
            const {totalCount, uploadedCount} = res.data || {};
            // const mockResponse = {
            //     "totalCount": 100,
            //     "uploadedCount": 100,
            //     "notUploadedCount": 0
            // }
            setTestOrderModalConfig({
                type: 'uploading',
                isOpen: uploadedCount < totalCount,
                totalCount: totalCount,
                progressCount: uploadedCount,
            });
            if (uploadedCount < totalCount) {
                setTimeout(() => {
                    getBulkTestOrderListCount()
                }, 1000)
            } else {
                getBulkOrderDetails();
                CommonService._communications.TableWrapperRefreshSubject.next({
                    moduleName: MODULE_NAME
                })
                setTimeout(() => {
                    setTestOrderModalConfig({
                        type: 'uploading',
                        isOpen: false,
                        totalCount: 0,
                        progressCount: 0,
                    });
                }, 500)
            }
        })
    }, [bulkOrderID, getBulkOrderDetails])

    const getBulkTestOrderGeneratedCount = useCallback(() => {
        CommonService._testOrder.getBulkTestOrderGeneratedCount(bulkOrderID).then(res => {
            const {totalCount, generatedCount} = res.data || {};
            // data = {
            //     "totalCount": 100,
            //     "generatedCount": 100,
            //     "notGeneratedCount": 0
            // }
            setTestOrderModalConfig({
                type: 'generating',
                isOpen: true,
                totalCount: totalCount,
                progressCount: generatedCount,
            });
            if (generatedCount < totalCount) {
                setTimeout(() => getBulkTestOrderGeneratedCount(), 1000)
            } else {
                getBulkOrderDetails();
                //Calling after .5 seconds because to show the 100% progress
                setTimeout(() => {
                    setTestOrderModalConfig({
                        type: 'generating',
                        isOpen: false,
                        totalCount: 0,
                        progressCount: 0,
                    });
                    setIsGenerateResultLoading(false);
                }, 500)
            }
        })
    }, [bulkOrderID, getBulkOrderDetails])

    const generateResult = useCallback(() => {
        const payload = {};
        setIsGenerateResultLoading(true)
        getBulkTestOrderGeneratedCount();
        CommonService._testOrder.generateBulkOrders(bulkOrderID, payload)
            .then((response: IAPIResponseType<any>) => {
                CommonService._alert.showToast(response?.message || "Generated Successfully", 'success');
                if (response?.success) {
                    setIsGenerateResultLoading(false);
                    getBulkOrderDetails();
                }
            })
            .catch((error: any) => {
                setIsGenerateResultLoading(false);
                CommonService._alert.showToast(error?.error || 'Error Generating Result', 'error');
            });
    }, [bulkOrderID, getBulkOrderDetails, getBulkTestOrderGeneratedCount]);

    useEffect(() => {
        if (bulkOrderID) {
            getBulkTestOrderListCount();
        }
    }, [bulkOrderID, getBulkTestOrderListCount]);

    return (
        <div className={'bulk-upload-view-component view-screen screen'}>
            <div className="view-details-wrapper">
                {
                    isBulkOrderDetailsLoading && <div className="h-v-center">
                        <LottieFileGenarationComponent
                            loop={true}
                            autoplay={true}
                            animationData={ImageConfig.LoadingLottieFile}/>
                    </div>
                }
                {
                    isBulkOrderDetailsLoadingFailed && <>
                        <StatusCardComponent title={"BulkOrder details failed to load"}/>
                    </>
                }
                {
                    isBulkOrderDetailsLoaded && <div className="view-details-wrapper">
                        <CardComponent className={'view-details-header-wrapper'}>
                            <div className="card-content">
                                <div className="view-details-card-header-button-wrapper">
                                    <div className="view-details-card-title">
                                        {bulkOrderDetails?.title}
                                    </div>
                                    <div className="view-details-options d-flex justify-content-space-between">
                                        <ButtonComponent
                                            type="button"
                                            color={"secondary"}
                                            disabled={!(bulkOrderDetails?.numberOfInValidOrders > 0)}
                                            variant={"outlined"}
                                            handleClick={() => setIsImportTestOrderDrawerOpen(true)}
                                        >
                                            Re-upload XLS
                                        </ButtonComponent> &nbsp;&nbsp;

                                        <ButtonComponent
                                            type="button"
                                            color={"primary"}
                                            disabled={bulkOrderDetails?.numberOfInValidOrders > 0 || bulkOrderDetails?.isGenerated}
                                            isLoading={isGenerateResultLoading}
                                            variant={"contained"}
                                            handleClick={generateResult}
                                        >
                                            Generate Orders
                                        </ButtonComponent>
                                    </div>
                                </div>
                                <div className="view-details-content">
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={2}>
                                            <DetailsDataKeyValueComponent
                                                title={"Added On"}>
                                                <div
                                                    className="view-details-value"> {commonService.formatDate(bulkOrderDetails?.createdAt)} </div>
                                            </DetailsDataKeyValueComponent>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <DetailsDataKeyValueComponent
                                                title={"Added by"}
                                                maxLength={19}>
                                                {bulkOrderDetails?.createdByDetails?.firstName + " " + bulkOrderDetails?.createdByDetails?.lastName}
                                            </DetailsDataKeyValueComponent>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <DetailsDataKeyValueComponent
                                                title={"Test Panel"}
                                                maxLength={19}
                                            >
                                                 {bulkOrderDetails?.testDetails?.name}
                                            </DetailsDataKeyValueComponent>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <DetailsDataKeyValueComponent
                                                title={"Valid Entries"}>
                                                <div
                                                    className="details-value">{bulkOrderDetails?.numberOfValidOrders} </div>
                                            </DetailsDataKeyValueComponent>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <DetailsDataKeyValueComponent
                                                title={"Invalid Entries"}>
                                                <div
                                                    className="details-value"> {bulkOrderDetails?.numberOfInValidOrders} </div>
                                            </DetailsDataKeyValueComponent>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        </CardComponent>

                        <div className="page-data-wrapper t-table-inside-details mrg-top-25 mrg-right-20 mrg-left-20">
                            <BulkTestOrderSessionListComponent
                                bulkOrderID={bulkOrderID}
                                dataColumns={bulkOrderDetails?.dataColumns}/>
                        </div>
                    </div>
                }
            </div>

            <DrawerComponent open={isImportTestOrderDrawerOpen}
                             className={"drawer-wrapper"}
                             closeOnBackDropClick={true}
                             closeOnEsc={true}
                             title={"Import Bulk Test Order File"}
                             onClose={() => setIsImportTestOrderDrawerOpen(false)}
            >
                <>
                    <ImportBulkTestOrderComponent
                        onImportDrawerClose={() => {
                            setIsImportTestOrderDrawerOpen(false)
                        }}
                        type={'reUpload'}
                        bulkOrderDetails={bulkOrderDetails}/>
                </>
            </DrawerComponent>
            <DialogComponent
                open={testOrderModalConfig.isOpen}
                direction={"down"}
                isShowCancel={false}
                maxWidth={'sm'}
            >
                <>
                    <div className={'result-preview-dialog'}>
                        <div className={'result-preview-dialog-image-wrapper'}>
                            <img src={ImageConfig.resultDialogImage} alt={'result'} className="result-dialog-image"/>
                        </div>
                        <div className={'result-preview-dialog-content-wrapper'}>
                            {testOrderModalConfig.progressCount} / {testOrderModalConfig.totalCount}
                        </div>
                        <div className={'result-preview-dialog-content-sub-header'}>
                            Test order are being {testOrderModalConfig.type === 'generating' ? 'generated' : 'uploaded'}...
                        </div>
                        {testOrderModalConfig.type === 'generating' &&
                            <div className={'result-preview-dialog-close-button'}>
                                <ButtonComponent
                                    type="button"
                                    color={"primary"}
                                    variant={"contained"}
                                    fullWidth={true}
                                    handleClick={() => navigate(CommonService._routeConfig.TestOrderListRoute())}
                                >
                                    Back to Test Order List
                                </ButtonComponent>
                            </div>}
                    </div>
                </>
            </DialogComponent>
        </div>
    );

};

export default BulkTestOrderViewComponent;
